export default "__VITE_ASSET__v9UchpM0__"